import { render, staticRenderFns } from "./envirenmental.vue?vue&type=template&id=47ef332b&scoped=true&"
import script from "./envirenmental.vue?vue&type=script&lang=js&"
export * from "./envirenmental.vue?vue&type=script&lang=js&"
import style0 from "./envirenmental.vue?vue&type=style&index=0&id=47ef332b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef332b",
  null
  
)

export default component.exports